import { Suspense, lazy } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { LazyLoad } from '../components/suspense/LazyLoad'
import { ROUTER_BASE } from '../constants'
import { PrivateRoute } from '../containers/views/private-router/PrivateRoute'
import { type HOCProps } from '../interfaces/common'
import { privateRoutes, publicRoutes } from './routes'

const DashboardApp = lazy(
  async () =>
    await import('../containers/layout/App').then((module) => ({
      default: module.Dashboard,
    }))
)

interface AppProps extends HOCProps {}

export default function Router(props: AppProps) {
  return (
    <BrowserRouter basename={ROUTER_BASE ?? ''}>
      <Suspense fallback={<LazyLoad />}>
        <Routes>
          {publicRoutes.map((route) => (
            // public routes
            <Route
              Component={route.component}
              key={route.path}
              path={route.path}
            />
          ))}

          <Route element={<PrivateRoute />}>
            {/* protected routes */}
            <Route element={<DashboardApp {...props} />} path='/'>
              {privateRoutes.map((route) => (
                <Route
                  Component={route.component}
                  key={route.path}
                  path={route.path}
                />
              ))}
            </Route>

            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
